//MAINNET
// export const WAX_CHAIN_ID = '1064487b3cd1a897ce03ae5b6a865651747e2e152090f99c1d19d44e01aea5a4';
// export const WAX_RPC_ENDPOINTS_HOST = "wax.cryptolions.io";
// export const WAX_RPC_ENDPOINTS_PROTOCOL = "https";

//TESTNET
export const WAX_CHAIN_ID = 'f16b1833c747c43682f4386fca9cbb327929334a762755ebec17f6f23c9b8a12';
export const WAX_RPC_ENDPOINTS_HOST = "testnet.waxsweden.org";
export const WAX_RPC_ENDPOINTS_PROTOCOL = "https";


//export const ATOMIC_ASSETS_API = 'https://wax.api.atomicassets.io/atomicassets/v1'; //MAINNET
export const ATOMIC_ASSETS_API = 'https://test.wax.api.atomicassets.io/atomicassets/v1'; //TESTNET

export const DEEPMINE_GAME = 'deepminegame';
export const EOSIO_TOKEN ='eosio.token';


export const ATOMIC_ASSETS='atomicassets';


